import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

let initialState = {
   results : []
};

export const TenantSlice = createSlice({

    name: 'tenants',
    initialState,
    reducers: {

    load : (state, action) => {
        console.log('TenantSlice:load')
        console.log(action.payload)
        const data = action.payload
        return {
            ...state,
            ...data
        }
    },

    onboard_email : (state, action) => {
        console.log('TenantSlice:onboard_email')
        console.log(action.payload)
        const data = action.payload
        return {
            ...state,
            results: state.results.map((ele, i) => {
                if (ele.id === data.tenant_id) {
                    return {
                        ...ele,
                        onboardemail : {...data}
                    }
                }

                return ele
                }
            )
        }
    },

   }
});


export const {
  load,
  onboard_email
} = TenantSlice.actions;

export default TenantSlice.reducer;
